module.exports = __webpack_public_path__ + "ed163d86f2822a2d2aaeeb3613a0a890.svg";